<template>
  <div class="add-agency">
    <div class="alert alert-danger text-left" role="alert"  v-if="errorMsgStatus">
      {{errorMsg}}
    </div>
    <div class="alert alert-success text-left" role="alert" v-if="successMsgStatus">
      <span style="text-transform: capitalize;">{{successMsg}}</span>
    </div>
    <!--Page Header-->
    <div class="row no-gutters mb-3 head-container">
      <div class="col-12 col-md-6 display-1">New Agency</div>
      <div class="col-12 col-md-6 mt-sm-2 mt-md-0 text-sm-left text-md-right">
        <button type="button" tabindex="1" id="add-agency-cancel" class="btn btn-outline-secondary" @click="redirectToList">Cancel</button>
        <button type="button" tabindex="1" class="btn btn-success" @click="saveAgency">Save Agency</button>
      </div>
    </div>
    <!--Tabbed Content-->
    <div class="mt-2 mb-4">
      <div>
        <b-tabs v-model="tabIndex">
          <b-tab title="Agency Details" class="mt-3" :disabled="agencyDetailTabStatus">
            <form>
            <div class="row no-gutters">
              <!--Agency Setup: Left Column-->
              <div class="col-12 col-md-6 mb-3">
              <div class="mr-md-4 pb-3 rounded shadow-sm">
                <div class="col-head py-2 px-3 rounded-top text-white">Agency Setup</div>
                <div class="float-right pr-3 mt-2 smaller-font-content"><span class="star">*</span>Required</div>
                <div class="px-3 my-2">
                  <div><label>Vendor Status<span class='star'>*</span></label></div>
                  <b-form-group id="agency_section0"
                  label-for="VendorStatus" class="radio-field">
                    <div class="field-input-radio" v-if="vendorStatusData.field_type === 'radio'">
                      <div class="input-group">
                        <div :aria-describedby="`${vendorStatusData.field_name}_describedby`" class="btn-group btn-group-toggle" data-toggle="buttons" role="radiogroup"  :aria-labelledby="vendorStatusData.field_name"
                          :class="{ 'error': errors.has(vendorStatusData.field_name) || vendorStatusData.has_error }">
                          <div v-for="(subItem, sKey) in vendorStatusData.values" :key="sKey"
                            class="btn-group-inner-div"
                            v-bind:class="{'btn btn-outline-light': true,
                            'active': (vendorStatusData.field_value === subItem.internal_value)}"
                            @click="setSwitchValueAdmin(vendorStatusData, subItem.internal_value, $event)">
                            <template v-if="subItem.visible && sKey == 0">
                              <input
                                :ref="vendorStatusData.field_name"
                                :name="vendorStatusData.field_name + '_radio_option'"
                                :id="vendorStatusData.field_name + '_radio_option_' + sKey"
                                type="radio"
                                class="radio-input-field"
                                :value="subItem.internal_value"><label :for="vendorStatusData.field_name + '_radio_option_' + sKey">{{ subItem.display_value }}</label>
                            </template>
                            <template v-else-if="subItem.visible">
                              <input
                                :ref="vendorStatusData.field_name"
                                :name="vendorStatusData.field_name + '_radio_option'"
                                :id="vendorStatusData.field_name + '_radio_option_' + sKey"
                                type="radio"
                                class="radio-input-field"
                                :value="subItem.internal_value"><label :for="vendorStatusData.field_name + '_radio_option_' + sKey">{{ subItem.display_value }}</label>
                            </template>
                          </div><div><span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(vendorStatusData.field_name)  || vendorStatusData.has_error }"></span></div>
                          <input
                            v-show="false"
                            :name="vendorStatusData.field_name"
                            :id="vendorStatusData.field_name"
                            type="text"
                            class="form-control"
                            v-model="vendorStatusData.field_value"
                            >
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                  <b-form-group id="agency_section2" class="mb-0" v-if="vendorStatusData.field_value ==='New'" label-for="VendorName">
                  <div><label>Vendor Name<span class='star'>*</span></label></div>
                  <b-form-input
                  id="VendorName"
                  name="VendorName"
                  v-model="form.VendorName"
                  v-validate="{ required: true, min:2 }"
                  ></b-form-input>
                  <!-- This will only be shown if the preceding input has an invalid state -->
                  <b-form-invalid-feedback
                    :force-show="true"
                    v-show="errors.has('VendorName')">
                    {{ errors.first('VendorName') }}
                  </b-form-invalid-feedback>
                  </b-form-group>
                  <div v-if="vendorStatusData.field_value ==='New'" class="mb-1 smaller-font-content">This name will be displayed and should be identifiable to anyone. Try to avoid using abbreviations or acronyms.</div>
                  <b-form-group id="agency_section1" v-if="vendorStatusData.field_value ==='Existing'" label-for="VendorId">
                    <div>
                      <label>Vendor<span class='star'>*</span></label>
                    </div>
                    <b-form-select
                    name="VendorId"
                    id="VendorId"
                    v-model="form.vendor"
                    :disabled="disableVendor"
                    :options="vendorOptions"
                    v-validate="{ required: true}"
                    size="sm" class="mt-1">
                    </b-form-select>
                    <b-form-invalid-feedback
                    :force-show="true"
                    v-show="errors.has('VendorId')">
                    {{ errors.first('VendorId') }}
                  </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                  id="agency_section3" class="mb-0"
                  label-for="agency_name"
                >
                <div><label>Agency Name<span class='star'>*</span></label></div>
                  <b-form-input
                  id="agency_name"
                  name="agency_name"
                  v-model="form.agencyName"
                  v-validate="{ required: true, min:2 }"
                  ></b-form-input>
                  <!-- This will only be shown if the preceding input has an invalid state -->
                  <b-form-invalid-feedback
                    :force-show="true"
                    v-show="errors.has('agency_name')">
                    {{ errors.first('agency_name') }}
                  </b-form-invalid-feedback>
                  </b-form-group>
                  <div class="mb-1 smaller-font-content">This name will be displayed and should be identifiable to anyone. Try to avoid using abbreviations or acronyms.</div>
                  <!-- MAYBE: NO AGENCY LOGO UPLOAD
                  <div class="form-group mb-3">
                    <label for="">Upload Agency Logo</label>
                    <input type="file" class="form-control-file" id="agency-logo">
                  </div>-->
                  <b-form-group id="agency_section5" class="mb-0" label-for="application_name">
                    <div>
                      <label>QRP Application<span class='star'>*</span></label>
                    </div>
                    <b-form-select
                    name="application_name"
                    id="application_name"
                    v-model="form.application"
                    :disabled="disableApplication"
                    :options="applicationOptions"
                    v-validate="{ required: true}"
                    size="sm" class="mt-1">
                    </b-form-select>
                  </b-form-group>
                  <b-form-invalid-feedback
                    :force-show="true"
                    v-show="errors.has('application_name')">
                    {{ errors.first('application_name') }}
                  </b-form-invalid-feedback>
                  <div class="mb-1 smaller-font-content">Agencies can only be assigned to a single QRP Application.</div>
                 <!-- TODO: ATLEAST ONE AGENCY ADMIN MUST EXIST BEFORE THIS QUESTION IS USED
                  <div class="form-group mb-2">
                    <label for="exampleFormControlSelect1">Agency Account Admin<span class="star">*</span></label>
                    <select class="form-control w-auto" id="exampleFormControlSelect1">
                      <option>-Select One-</option>
                      <option>Admin Option 1</option>
                      <option>Admin Option 2</option>
                      <option>Admin Option 3</option>
                      <option>Admin Option 4</option>
                      <option>Admin Option 5</option>
                    </select>
                  </div>-->
                </div>
              </div>
              </div>
              <!--Agency Details: Right Column-->
              <div class="col-12 col-md-6 mb-3">
              <div class="ml-md-4 pb-3 rounded shadow-sm">
                <div class="col-head py-2 px-3 rounded-top text-white">Agency Details</div>
                <div class="px-3 py-2">
                  <b-form-group
                  id="agency_section6"
                  label="Phone Number"
                  label-for="phone_number"
                >
                <the-mask
                name="phone_number"
                id="phone_number"
                type="tel"
                placeholder="XXX-XXX-XXXX"
                v-model="masked_input_value"
                mask="###-###-####"
                v-bind:class="{'form-control': true, 'error': errors.has('phone') }">
                </the-mask>
                 <input
                  v-show="false"
                  name="phone"
                  type="text"
                  v-validate="'digits:10'"
                  v-model="masked_input_value">
                  <b-form-invalid-feedback
                    :force-show="true"
                    v-show="errors.has('phone')">
                    {{ errors.first('phone') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                  <b-form-group
                  id="agency_section7"
                  label="Agency Address"
                  label-for="agency_address"
                >
                  <b-form-input id="agency_address" name="agency_address"
                  v-model="form.agencyAddress"></b-form-input>
                </b-form-group>
                  <b-form-group
                  id="agency_section5"
                  label="City"
                  label-for="agency_city"
                >
                  <b-form-input id="agency_city" name="agency_city" v-model="form.agencyCity"></b-form-input>
                </b-form-group>
                  <div class="col-md-12 row">
                    <b-form-group
                    id="agency_section8"
                    label="State"
                    class="mb-2 float-left mr-3 col-md-2 p-0"
                    label-for="agency_state"
                  >
                  <b-form-input id="agency_state"
                  name="agency_state"
                  maxlength="2"
                  v-validate="'alpha'"
                  class="col-md-10"
                  v-model="form.agencyState"></b-form-input>
                  <b-form-invalid-feedback
                    :force-show="true"
                    v-show="errors.has('agency_state')">
                    {{ errors.first('agency_state') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    id="agency_section9"
                    label="Zip Code"
                    class="mb-2 float-left mr-3"
                    label-for="agency_zipcode"
                  >
                  <b-form-input id="agency_zipcode"
                  name="agency_zipcode"
                  type="text"
                  v-validate="'digits:5|length:5'"
                  size="5" class="state-width" v-model="form.agencyZipcode"></b-form-input>
                  <b-form-invalid-feedback
                    :force-show="true"
                    v-show="errors.has('agency_zipcode')">
                    {{ errors.first('agency_zipcode') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                </div>
              </div>
            </div>
            </div>
          </div>
          </form>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import fetchData from '../../../services/fetchData';
import postData from '../../../services/postData';
import common from '../../../services/common';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
      form:{
        application: null,
        vendor: null,
        VendorName: '',
      },
      masked_input: '',
      vendorStatus: 'New',
      agencyName: '',
      errorMsgStatus: false,
      errorMsg: '',
      successMsgStatus: false,
      successMsg: '',
      agencyID: '',
      tabIndex: 1,
      agencyDetailTabStatus: false,
      applicationOptions:[{ value: null, text: 'Select' }],
      vendorOptions:[{ value: null, text: 'Select' }],
      disableApplication: false,
      disableVendor: false,
      vendorStatusData:{
        field_type: 'radio',
        field_name: 'VendorStatus',
        field_value: 'New',
        is_enabled: true,
        has_error: false,
        visible: true,
        values: [{ 
          visible: true,
          internal_value: 'New',
          display_value: 'New Vendor',
          },
          { 
          visible: true,
          internal_value: 'Existing',
          display_value: 'Existing Vendor',
          }],
      },
    };
  },
  computed: {
    masked_input_value: {
      get: function () {
        return this.masked_input;
      },
      set: function (newValue) {
        this.masked_input = newValue;
        this.form.phone = this.masked_input;
      },
    },
  },  
  methods: {
    /**
     * Redirect to agency list page
     */
    redirectToList() {
      this.$router.push({ name: 'agencymanager' });
    },
    async saveAgency() {
     if(this.tabIndex == 0) {
        const isValid = await this.$validator.validateAll();
        if(!isValid) {
          return false;
        }
        let inputData = {};
        if (this.vendorStatusData.field_value === 'New') {
          inputData =  {
              vendorStatus: this.vendorStatusData.field_value,
              agencyName: this.form.agencyName,
              vendorName: this.form.VendorName,
              applicationId: this.form.application,
              phoneNumber: this.form.phone,
              address: this.form.agencyAddress,
              city: this.form.agencyCity,
              state: this.form.agencyState,
              zipCode: this.form.agencyZipcode,
          };
        } else {
          inputData =  {
              vendorStatus: this.vendorStatusData.field_value,
              vendorId: this.form.vendor,
              agencyName: this.form.agencyName,
              applicationId: this.form.application,
              phoneNumber: this.form.phone,
              address: this.form.agencyAddress,
              city: this.form.agencyCity,
              state: this.form.agencyState,
              zipCode: this.form.agencyZipcode,
          };
        }
        let requestParams = {
            url: '/agencies/create',
            data: inputData,
          };
        postData.postRuleDashboard(requestParams).then((response) => {
          this.successMsg = this.form.agencyName+ ' agency created.';
          this.successMsgStatus = true;
          this.vendorStatusData.field_value = 'New';
          this.form.agencyName = '';
          this.form.VendorName = '';
          this.form.application = '';
          if (this.form.phone) {
            this.masked_input_value = '';
          }
          if (this.form.agencyAddress) {
            this.form.agencyAddress = '';
          }
          if (this.form.agencyCity) {
            this.form.agencyCity = '';
          }
          if (this.form.agencyState) {
            this.form.agencyState = '';
          }
          if (this.form.agencyZipcode) {
            this.form.agencyZipcode = '';
          }
          if (this.form.vendor) {
            this.form.vendor = '';
          }
          setTimeout(() => {
            this.successMsgStatus = false;
          }, 10000);
          gtag('config', '<%= process.env.GAID %>', { page_path: '/dashboard/agencies/addagency-carriers' }); // Add page view to GA
        }).catch((error) => {
          if(error && error.response && error.response.data && error.response.data.Message) {
            this.errorMsg = error.response.data.Message;
          } else {
            this.errorMsg = 'Error in saving data';
          }
          this.errorMsgStatus = true;
          setTimeout(() => {
            this.errorMsgStatus = false;
          }, 10000);
        });
     }
    },
    /**
     * set radio control value also treat as switch control. Also call API rule if exists
     * @param {*} formData
     * @param {*} switchVal
     */
    setSwitchValueAdmin(formData, switchVal) {
      if (formData.is_enabled) {
        const switchId = formData.field_name;
        if (document.getElementById(switchId).value === switchVal) {
          // this.$validator.validate(switchId);
          return;
        }
        document.getElementById(switchId).value = switchVal;
        this.vendorStatusData.field_value = switchVal;
        this.form.VendorName = '';
        this.form.vendor = null;
      }
    },
    /**
     *  focus shift to cancel button from last field on form
     */
    checkTabSequence(e) {
      if(e.keyCode == 9) {
        if(e.preventDefault) {
            e.preventDefault();
        }
        document.getElementById('add-agency-cancel').focus();
        return false;
      }
    },
  },
  mounted() {
    fetchData.getDashboard('agencies/create').then((response) => {
      if(response.data) {
        if (response.data.applications) {
          for (let aCnt = 0; aCnt < response.data.applications.length; aCnt += 1) {
            this.applicationOptions.push({'value': response.data.applications[aCnt].appId, 'text': response.data.applications[aCnt].displayName })
          }
        }
        if (response.data.vendors) {
          for (let aCnt = 0; aCnt < response.data.vendors.length; aCnt += 1) {
            this.vendorOptions.push({'value': response.data.vendors[aCnt].vendorId, 'text': response.data.vendors[aCnt].vendorName })
          }
        }
      }
    }).catch((error) => {
      console.log('error', error);
    });

    if(!common.checkPermission('GetAllAgencies')) {
      this.disableAgency = true;
    }
    /**
     * add event listener to last field email on form to move next tab to cancel button
     */
    const myEmailInput = document.getElementById("agency_zipcode");
    if(myEmailInput.addEventListener) {
      myEmailInput.addEventListener('keydown',this.checkTabSequence,false);
    }
    /**
     * focus dashboard link as a first inter-active element on page
     */
  //  const pageFirstElement = document.getElementsByClassName('breadcrumb-first-item');
  //  pageFirstElement[0].focus();
  },
};
</script>
<style scoped>
/**PAGE HEADER STYLING**/
.btn-outline-secondary {
  color: #595959;
  border-color: #595959;
} 
.btn-outline-secondary:hover, .btn-outline-secondary:active{
  color: #fff !important;
  border-color: #595959 !important;
  background-color: #595959 !important;
}
.btn-outline-secondary:focus {
  box-shadow:  0 0 0.2rem rgba(51, 51, 51, .45);
}

/**TAB PANE STYLING**/
.tab-content .tab-pane{
  padding: 0;
  outline: none;
}

/**COLUMN STYLING**/
.col-head {
  background-color: #00162B;
}

/**FORM STYLING**/
/**Extra large devices (large desktops, 1200px and up)**/
@media (min-width: 1200px) {
  form .form-group{
    width: 50%;
  }
}

/**Large devices (desktops, 992px and up)**/
@media (max-width: 992px) {
  form .form-group{
    width: 100%;
  }
}

/**Medium devices (tablets, 768px and up)**/
@media (max-width: 768px) {
  form .form-group{
    width: 100%;
  }
}
/**Small devices (landscape phones, 576px and up)**/
@media (max-width: 576px) {
  form .form-group{
    width: 100%;
  }
}

/**FIELD LABEL STYLING**/
label {
  margin-bottom: 0.25rem;
}
.add-agency-product {
  max-width: 555px;
}
</style>
<style>
/**TAB NAV STYLING**/
.nav-tabs{
  border-bottom: 2px solid #003366;
}
  .nav-tabs .nav-link{
    color: #003366;
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
    color: #FFFFFF;
    background-color: #003366;
    border-color: #003366 #003366 #003366;
  }
    .nav-tabs .nav-link:hover{
      border-color: #003366 #003366 #003366;
    }
    .nav-tabs .nav-link.active{
      background-color: #003366 !important;
      border-color: #003366 #003366 #003366 !important;
    }
    .nav-tabs .nav-link.disabled{
      color: #CCCCCC;
      border: none;
    }
.tab-content {
  border: none !important;
}

/**Side-by-Side fields**/
form .form-group.float-left {
  width: auto !important;
}
.add-agency label.btn:focus-within {
  color: #fff;
  background-color: #001a33;
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
}
.btn-outline-light {
/**NEW-TOM: Update color, border-color**/
  color: #333333;
  background-color: #FFFFFF;
  border-color: #CCCCCC;
}
.btn-outline-light:hover {
/**NEW-TOM: Update color, background-color, border-color**/
  background-color: #677580;
  color: #FFFFFF;
}
.add-agency .btn-group-toggle:focus-within {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show > .btn-outline-light.dropdown-toggle {
/**NEW-TOM: Update color, background-color, border-color**/
  color: #FFFFFF;
  background-color: #00162B;
  border-color:#00162B;
}
.add-agency .field-input-radio .btn-group-toggle:focus-within{
  color: #5c6873;
  border-color: #8ad4ee;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
  border-radius: 0.25rem !important;
}
.btn-group.btn-group-toggle .btn {
    padding: 0.1875rem 1.5rem 0;
}
label {
    display: inline-block;
    margin-bottom: 0.125rem;
    font-size: 0.75rem;
    line-height: 1.25rem;
}

.radio-field .field-input-radio .input-group .btn-group > .btn-group-inner-div.btn.btn-outline-light:nth-last-child(3n) {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}.field-input-radio .input-group .btn-group > .btn-group-inner-div.btn.btn-outline-light:not(:last-child) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/agencies/AddAgency.vue?a78807dc